import React from "react";
import { FlexContainer, RegularText, TitleInput, IconWrapper } from "./cx-components.style";
import { useItem } from "shared/dynamic-imports";
import { IconDispatcher } from "shared/Icons";
import { useTranslation } from "react-i18next";
import Moment from "react-moment";
import Editor from "shared/components/Editor/Editor";

type Props = {
	disabled?: boolean;
	disabledDescription: boolean;
	icon: string;
	labelPlaceholder?: string;
	renderCustomIcon?: any;
};

export default function HeaderTitle({ disabled,disabledDescription, icon, renderCustomIcon, labelPlaceholder = "ENTER_NAME" }: Props): JSX.Element {
	const { currentItem, handleChange, handleBlur } = useItem();
	const { t } = useTranslation();
	if (!currentItem) return <></>;
	return (
		<>
			<FlexContainer className="py-4">
				{renderCustomIcon ? renderCustomIcon() : <IconWrapper>{IconDispatcher(icon, "", { size: "lg" })}</IconWrapper>}
				<TitleInput
					value={currentItem.name}
					fontSize="20px"
					fontWeight={600}
					className="mx-2"
					name="name"
					placeholder={t(labelPlaceholder)}
					onBlur={() => handleBlur("name")}
					onChange={(e: { target: { value: string } }) => handleChange("name", e.target.value.truncate(100,true))}
					title={currentItem?.name?.length > 0 ? currentItem.name : undefined}
					disabled={disabled}
				/>
			</FlexContainer>
			<FlexContainer gap={48}>
				<RegularText fontSize="12px" fontWeight={400} color="#595959">
					{t("CREATED_ON")}
					<Moment format="DD MMM, YYYY" date={currentItem?.createdOn} className="ms-1" />
				</RegularText>
				<RegularText fontSize="12px" fontWeight={400} color="#595959">
					{t("UPDATED_ON")}
					<Moment format="DD MMM, YYYY" date={currentItem?.lastUpdated} className="ms-1" />
				</RegularText>
				{currentItem?.modifiedBy && <RegularText fontSize="12px" fontWeight={400} color="#595959">
					{t("UPDATED_BY")} {currentItem?.modifiedBy}
				</RegularText>}
			</FlexContainer>
			<FlexContainer className="p-1 my-3" focus={true} key={currentItem.id}>
				<Editor
					value={currentItem.description}
					onChange={(value: string) => handleChange("description", value?.truncate(20000,true))}
					onUpdate={() => handleBlur("description")}
					placeholder={t("ENTER_DESCRIPTION")}
					disabled={disabledDescription??disabled}
				/>
			</FlexContainer>
		</>
	);
}
